import { render, staticRenderFns } from "./ztOption.vue?vue&type=template&id=745896b4&"
import script from "./ztOption.vue?vue&type=script&lang=js&"
export * from "./ztOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports